import { Box } from "@mui/material";
import { useEffect, useReducer, useState } from "react";

import Modal from "@mui/material/Modal";

import {
  addConfigVal,
  updateConfigVal,
} from "../../apis/createEnvApi/createEnvApi";
import { useSelector } from "react-redux";
import editIcon from "../../assets/icons/editIcon.svg";
import closeIcon from "../../assets/icons/closeIcon.svg";
import "./MenuConfigActions.css";

const MenuConfigActions = (params: any) => {
  //   const { dispatch } = useValue();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );

  const [openEditModal, setOpenEditModal] = useState(false);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const [editFormInput, setEditFormInput] = useState<any>({});

  useEffect(() => {}, []);

  const handleEditInput = (val: any, fieldName: string) => {
    console.log("date-->", val);
    let editFormSData: any = editFormInput;
    editFormSData[fieldName] = val;
    setEditFormInput(editFormSData);
  };

  const handleEditSubmit = (event: any) => {
    event.preventDefault();
    console.log("edit DATA--", editFormInput);

    let payload = {
      Emp_Id: EmpId,
      Client_Id: ActiveClient.Client_Id,
      Env_Id: params.selectedEnv.Env_Id,
      Env_Name:params.selectedEnv.Env_Name,
      Category_Id: params.item.Code_Category,
      Config_Data: {
        Code: params.item.Code_Code,
        UpdatedCode: editFormInput.UpdatedCode
          ? editFormInput.UpdatedCode
          : null,
        Code_Date_Effective: editFormInput.Code_Date_Effective
          ? editFormInput.Code_Date_Effective
          : null,
        Code_Date_Expiration: editFormInput.Code_Date_Expiration
          ? editFormInput.Code_Date_Expiration
          : null,
        Code_Decode_Sort_Order: editFormInput.Code_Decode_Sort_Order
          ? editFormInput.Code_Decode_Sort_Order
          : null,
        UpdatedShort_Dsc: editFormInput.UpdatedShort_Dsc
          ? editFormInput.UpdatedShort_Dsc
          : null,
        UpdatedLong_Dsc: editFormInput.UpdatedLong_Dsc
          ? editFormInput.UpdatedLong_Dsc
          : null,
        UpdatedLocale_Id: editFormInput.UpdatedLocale_Id
          ? editFormInput.UpdatedLocale_Id
          : null,
      },
    };
    updateConfigVal(payload, async (response: any) => {
      console.log("updateMenu::--", response);
      if (response) {
        params.getAllConfig();
        setOpenEditModal(false);
      }
    });
  };

  return (
    <>
      <div onClick={() => setOpenEditModal(true)}>
        <img src={editIcon} className="icon-wd-sm" />
      </div>

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        className="modal-1"
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">Edit</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                setOpenEditModal(false);
              }}
            >
              <img src={closeIcon} className="icon-md" />
            </div>
          </div>
          <form onSubmit={handleEditSubmit}>
            <div className="model-1-form-body">
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Language
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  defaultValue={params.item.Code_Decode_Locale_Id}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "UpdatedLocale_Id")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Key Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  defaultValue={params.item.Code_Code}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "UpdatedCode")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Display Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  defaultValue={params.item.Code_Decode_Short_Desc}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "UpdatedShort_Dsc")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Description
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  defaultValue={params.item.Code_Decode_Long_Desc}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "UpdatedLong_Dsc")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Start Date
                </label>
                <input
                  type="date"
                  className="input-field-1"
                  defaultValue={params.item.Code_Date_Effective.split("T")[0]}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "Code_Date_Effective")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  End Date
                </label>
                <input
                  type="date"
                  className="input-field-1"
                  defaultValue={params.item.Code_Date_Expiration.split("T")[0]}
                  onChange={(e) =>
                    handleEditInput(e.target.value, "Code_Date_Expiration")
                  }
                />
              </div>
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  setOpenEditModal(false);
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
              >
                <div>Done</div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default MenuConfigActions;
